<template>
  <SfButtonDs
    v-show="!open"
    variant="tertiary"
    icon-only
    icon-before="bars"
    :aria-label="I18n.t('companies_overview.expand_sidepane')"
    data-testid="insights-sidepane-toggle"
    @click="onClick"
  />
</template>

<script setup lang="ts">
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useInsightsSidepaneVisibility } from '../composables/use-insights-sidepane-visibility'

defineOptions({ name: 'InsightsSidepaneToggle' })

const I18n = useI18n()
const { open, setOpen } = useInsightsSidepaneVisibility()

function onClick(): void {
  setOpen(true)
}
</script>
